import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// `getAuth()` runs at module load and throws `auth/invalid-api-key` on an
// empty apiKey — which would crash SSR before AuthGuard ever runs. In
// dev-auth mode (NEXT_PUBLIC_DEV_AUTH=1) the app never talks to Firebase, so
// fall back to a harmless non-empty placeholder when the vars are unset. This
// lets `pnpm dev` boot without a real Firebase project; production always
// sets the real values.
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "dev-auth-placeholder",
  authDomain:
    process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "dev.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "dev-project",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const firebaseAuth = getAuth(app);
